import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { setInterceptors } from "@/api";

import FontAwesomeIcon from "./utils/font-awesome.js";
import VueApexCharts from "vue-apexcharts";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "./assets/css/consumerSpaceStyles.css";


Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);
Vue.component("font-awesome-icon", FontAwesomeIcon);


new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");


setInterceptors();